"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

exports.ConfigurationContext = react_1.createContext({});

exports.withConfiguration = function (Component) {
  var _a;

  return _a =
  /** @class */
  function (_super) {
    __extends(WithLoading, _super);

    function WithLoading(props) {
      var _this = _super.call(this, props) || this;

      _this.orchestrateConfiguration = function (props) {
        var contextConfiguration = _this.context;
        var propsConfiguration = props.configuration;

        if (propsConfiguration) {
          return ksys_app_template_1.utils.object.deepMergeObjects(contextConfiguration, propsConfiguration);
        }

        return contextConfiguration;
      };

      _this.getStateFromProps = function (props) {
        return {
          mergedConfiguration: _this.orchestrateConfiguration(props),
          overrideConfiguration: props.configuration
        };
      };

      _this.state = {};
      return _this;
    }

    Object.defineProperty(WithLoading.prototype, "configuration", {
      get: function get() {
        return this.state.mergedConfiguration;
      },
      enumerable: true,
      configurable: true
    }); // The parameters must be of type "any" otherwise it will break ¯\_(ツ)_/¯

    WithLoading.getDerivedStateFromProps = function (nextProps, previousState) {
      if (nextProps.configuration !== previousState.overrideConfiguration) {
        return {
          mergedConfiguration: null
        };
      }

      return null;
    };

    WithLoading.prototype.componentDidUpdate = function () {
      if (!this.state.mergedConfiguration) {
        this.setState(this.getStateFromProps(this.props));
      }
    };

    WithLoading.prototype.componentDidMount = function () {
      if (!this.state.mergedConfiguration) {
        this.setState(this.getStateFromProps(this.props));
      }
    };

    WithLoading.prototype.render = function () {
      var props = __rest(this.props, []);

      var configuration = this.context;
      return react_1.default.createElement(Component, __assign({
        configuration: configuration
      }, props));
    };

    return WithLoading;
  }(react_1.default.Component), _a.contextType = exports.ConfigurationContext, _a;
};